import { IEntity } from 'app/projects/entity/src/lib/interfaces/entity.interface';
import { IUnsplashImageQuery } from '../interfaces/unsplash-image.query.interface';

export class UnsplashImage implements IEntity {
    id: string;
    selected: boolean;
    createdAt: Date;
    updatedAt: Date;
    promotedAt: Date;
    width: number;
    height: number;
    color: string;
    blurHash: string;
    description: null;
    altDescription: null;
    url: string;
    urls: {
        raw: string;
        full: string;
        regular: string;
        small: string;
        thumb: string;
    };
    links: {
        self: string;
        html: string;
        download: string;
        downloadLocation: string;
    };
    categories: Array<any>;
    likes: number;
    likedByUser: boolean;
    currentUserCollections: Array<any>;
    sponsorship: {
        impressionUrls: Array<string>;
        tagline: string;
        taglineUrl: string;
        sponsor: {
            id: string;
            updatedAt: Date;
            username: string;
            name: string;
            firstName: string;
            lastName: string;
            twitterUsername: string;
            portfolioUrl: string;
            bio: string;
            location: string;
            links: {
                self: string;
                html: string;
                photos: string;
                likes: string;
                portfolio: string;
                following: string;
                followers: string;
            };
            profileImage: {
                small: string;
                medium: string;
                large: string;
            };
            instagramUsername: string;
            totalCollections: number;
            totalLikes: number;
            totalPhotos: number;
            acceptedTos: boolean;
        };
    };
    user: {
        id: string;
        updatedAt: Date;
        username: string;
        name: string;
        firstName: string;
        lastName: string;
        twitterUsername: string;
        portfolioUrl: string;
        bio: string;
        location: string;
        links: {
            self: string;
            html: string;
            photos: string;
            likes: string;
            portfolio: string;
            following: string;
            followers: string;
        };
        profileImage: {
            small: string;
            medium: string;
            large: string;
        };
        instagramUsername: string;
        totalCollections: number;
        totalLikes: number;
        totalPhotos: number;
        acceptedTos: boolean;
    };

    constructor(query: IUnsplashImageQuery) {
        if (query) {
            this.id = query.id.toString();
            this.selected = false;
            this.createdAt = query.created_at;
            this.updatedAt = query.updated_at;
            this.promotedAt = query.promoted_at;
            this.width = query.width;
            this.height = query.height;
            this.color = query.color;
            this.blurHash = query.blur_hash;
            this.description = query.description;
            this.altDescription = query.alt_description;
            this.url = query.urls.regular;
            this.urls = query.urls;
            this.links = {
                self: query.links.self,
                html: query.links.html,
                download: query.links.download,
                downloadLocation: query.links.download_location,
            };
            this.categories = query.categories;
            this.likes = query.likes;
            this.likedByUser = query.liked_by_user;
            this.currentUserCollections = query.current_user_collections;
            if (query.sponsorship) {
                this.sponsorship = {
                    impressionUrls: query.sponsorship.impression_urls,
                    tagline: query.sponsorship.tagline,
                    taglineUrl: query.sponsorship.tagline_url,
                    sponsor: {
                        id: query.sponsorship.sponsor.id.toString(),
                        updatedAt: query.sponsorship.sponsor.updated_at,
                        username: query.sponsorship.sponsor.username,
                        name: query.sponsorship.sponsor.name,
                        firstName: query.sponsorship.sponsor.first_name,
                        lastName: query.sponsorship.sponsor.last_name,
                        twitterUsername: query.sponsorship.sponsor.twitter_username,
                        portfolioUrl: query.sponsorship.sponsor.portfolio_url,
                        bio: query.sponsorship.sponsor.bio,
                        location: query.sponsorship.sponsor.location,
                        links: query.sponsorship.sponsor.links,
                        profileImage: query.sponsorship.sponsor.profile_image,
                        instagramUsername: query.sponsorship.sponsor.instagram_username,
                        totalCollections: query.sponsorship.sponsor.total_collections,
                        totalLikes: query.sponsorship.sponsor.total_likes,
                        totalPhotos: query.sponsorship.sponsor.total_photos,
                        acceptedTos: query.sponsorship.sponsor.accepted_tos,
                    },
                };
            }
            this.user = {
                id: query.user.id.toString(),
                updatedAt: query.user.updated_at,
                username: query.user.username,
                name: query.user.name,
                firstName: query.user.first_name,
                lastName: query.user.last_name,
                twitterUsername: query.user.twitter_username,
                portfolioUrl: query.user.portfolio_url,
                bio: query.user.bio,
                location: query.user.location,
                links: query.user.links,
                profileImage: query.user.profile_image,
                instagramUsername: query.user.instagram_username,
                totalCollections: query.user.total_collections,
                totalLikes: query.user.total_likes,
                totalPhotos: query.user.total_photos,
                acceptedTos: query.user.accepted_tos,
            };
        }
    }
}
